import {AgentCalendarProduct} from './agent-calendar-product';

export class AgentCalendar {
  date: string;
  products: AgentCalendarProduct[];
}



// WEBPACK FOOTER //
// ./src/app/shared/api/model/agent-calendar.ts